import { Box, Divider, Flex } from "@chakra-ui/react";
import { Conlogo } from "@root/assets/icons";
import { ForgotPasswordContainer } from "@root/commonStyles/commonStyle";
import { CommonFooter } from "@root/components/auth/commonFooter";
import { CenterFlex } from "@root/components/dashboard/chat/style";
import { LanguageSwitcher } from "@root/components/language-switcher";
import React from "react";
import { Outlet } from "react-router-dom";

const ForgotPasswordLayout: React.FC = () => {
  return (
    <ForgotPasswordContainer
      width={"100vw"}
      height={"100vh"}
      overflow={"hidden"}
    >
      <Box height={"100%"} overflowY={"scroll"} pt={4}>
        <Flex justifyContent={"center"} alignItems={"center"} width={"100%"}>
          <Outlet />
        </Flex>
      </Box>
      <Box width={"100%"}>
        <CommonFooter />
      </Box>
    </ForgotPasswordContainer>
  );
};

export default ForgotPasswordLayout;
